import { useEffect, useState } from "react";
import OtpInput from "react-otp-input";

const EnterCode = (props) => {
  const [sessionCode, setSessionCode] = useState("");
  const [isConnectButtonEnabled, setIsConnectButtonEnabled] = useState(false);

  useEffect(() => {
    // Paste handler is bound at the document level so a user can paste a
    // 6-digit code anywhere within the pane and have it hydrate the OTP
    // inputs — react-otp-input's own paste handling misses trailing digits
    // in some browsers.
    document.addEventListener("paste", handleToPastedNumericInput, false);
    return () => {
      document.removeEventListener("paste", handleToPastedNumericInput);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSessionCodeValueChange = (value) => {
    // Session codes are 6 digits and must not start with 0.
    setSessionCode(value);
    setIsConnectButtonEnabled(value?.length === 6 && value[0] !== "0");
  };

  const handleToPastedNumericInput = (e) => {
    let clipboardData, pastedData;

    e.stopPropagation();
    e.preventDefault();

    clipboardData = e.clipboardData || window.clipboardData;
    pastedData = clipboardData.getData("Text");

    // Strip any non-digit characters — the user may have copied the code
    // with surrounding whitespace, dashes, or a "code:" prefix.
    const replaceData = pastedData?.match(/\d+/g)?.join("");
    handleSessionCodeValueChange(replaceData);

    const sessionCodeInput = document.getElementsByClassName("cb-session-input");
    if (replaceData && replaceData?.length >= 5) {
      sessionCodeInput[5]?.focus();
    } else {
      sessionCodeInput[replaceData?.length]?.focus();
    }
  };

  return (
    <div className="cb-enter-code">
      <span className="cb-enter-code-text">Connect using code</span>
      <div className="cb-enter-code-form">
        <div className="cb-enter-code-row">
          {/* react-otp-input renders its OWN container div (with inline
              display:flex,alignItems:center). Pass containerStyle as a
              className so we can style that actual container from CSS —
              gap between inputs, extra gap between col 3 and col 4, and
              the ::before dash all live on .cb-otp-container. */}
          <OtpInput
            value={sessionCode}
            onChange={handleSessionCodeValueChange}
            numInputs={6}
            renderSeparator=""
            inputType="tel"
            containerStyle="cb-otp-container"
            renderInput={(inputProps) => (
              <div className="cb-enter-code-col">
                <input
                  {...inputProps}
                  className="cb-session-input"
                  data-testid="input"
                />
              </div>
            )}
          />
          <button
            type="submit"
            className={
              "cb-connect-btn" +
              (isConnectButtonEnabled ? "" : " cb-connect-btn-disabled")
            }
            disabled={!isConnectButtonEnabled}
            onClick={() => props.redirectToCobrowse(sessionCode)}
          >
            Connect
          </button>
        </div>
      </div>
      <span className="cb-enter-code-text">
        Or connect to a device from the list below.
      </span>
    </div>
  );
};

export default EnterCode;
